import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-version-dialog',
  templateUrl: './version-dialog.component.html',
  styleUrls: ['./version-dialog.component.scss']
})
export class VersionDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
